export default __webpack_public_path__ + "static/media/Hands_Black.db72c267.png";